import React, { useState, useEffect } from "react";
import {
  getAllItemsSearch,
  getAllGeneralLedger,
  getAllSupplierSearch,
} from "../../api/endpoints/search";
import { getTankById } from "../../api/endpoints/tank";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import { EMeters } from "../../enums/meters";
import {
  getVoucher,
  saveData,
  getData,
  updatePurchase,
  deleteSingleInvoivce,
  deleteInvoivce,
  descPurchase,
  ascPurchase,
  onePreData,
  oneNextData,
} from "../../api/endpoints/purchase";

import SideBar from "../sidebar/sideBar";
import "./purchase.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import { latestDate } from "../../api/endpoints/meter";
import { updateSingleItem } from "../../api/endpoints/item";
import { getSiteRefrence } from "../../api/endpoints/refrences";
import { deleteSale, getAlert } from "../../api/endpoints/alert";

const { Option } = Select;

const Purchase = () => {
  const { user, access_token } = useSelector(authSelector);
  const [isVisible, setIsVisible] = useState(true);
  const [typeLast, setTypeLast] = useState("");
  const [voucher, setVoucher] = useState();
  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [allowedShift, setAllowedShift] = useState();

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    items: [],
    code: "",
    name: "",
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    quantity: "",
    purchaseRate: "",
    saleRate: "",
    cashAmount: "",
    creditAmount: "",
    rebate: "",
    withHoldingTax: "",
    salesTax: "",
    freight: "",
    lorryTip: "",
    depoExp: "",
    cmpRate: "",
    invoiceNo: "",
    invoiceDate: "",
    lorryNo: "",
    shortDip: "",
    shortQty: "",
    cheque: "",
    tanks: [],
    tank: "",
  });

  const clearState = () => {
    setIsVisible(true);
    setState({
      items: state.items,
      code: "",
      name: "",
      parties: state.parties,
      partyId: "",
      partyName: "",
      ledgerCodes: state.ledgerCodes,
      glCode: "",
      glDescription: "",
      quantity: "",
      purchaseRate: "",
      saleRate: "",
      cashAmount: "",
      creditAmount: "",
      rebate: "",
      withHoldingTax: "",
      salesTax: "",
      freight: "",
      lorryTip: "",
      depoExp: "",
      cmpRate: "",
      invoiceNo: "",
      // invoiceDate: "",
      lorryNo: "",
      shortDip: "",
      shortQty: "",
      cheque: "",
      tanks: state.tanks,
      tank: "",
    });
  };

  const clearStates = () => {
    clearState();
    setTypeLast("");
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------- ADD VOUCHER ---------------
  console.log(dateEntered, "dateEnteredOn");

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    console.log(result, "result");
    if (result.success) {
      setIsVisible(false);
      setVoucher(result.data);
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };

  // ------------------ SAVE DATA -----------------
  console.log(state, "state-=-=-=", type);

  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
    setAllowedShift(_refrences.data.allowedShift);
  };

  useEffect(() => {
    getRefrences();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const [allowedShift, setAllowedShift] = useState();
  // if(shift > allowedShift) return message.error(`Your allowed shifts are ${allowedShift}`)

  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (shift > allowedShift)
      return message.error(`Your allowed shifts are ${allowedShift}`);
    if (itemsQueue.length === 0) return message.error("Add minimun 1 item");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          partyId: Number(curr.partyId),
          // refrenceNumber: curr.invoiceNo,
          itemCode: curr.code,
          quantity: Number(curr.quantity),
          purchaseRate: Number(curr.purchaseRate),
          cashAmount: Number(curr.cashAmount),
          withHoldingTax: Number(curr.withHoldingTax),
          description: "",
          creditAmount: Number(curr.creditAmount),
          tankNumber: curr.tank,
          invoiceNumber: curr.invoiceNo,
          invoiceDate: curr.invoiceDate,
          generalLedgerCode: curr.glCode,
          saleRate: Number(curr.saleRate),
          saleTax: Number(curr.salesTax),
          gst: Number(curr.rebate),
          shortDip: Number(curr.shortDip),
          shortQuantity: Number(curr.shortQty),
          lorryNumber: curr.lorryNo,
          frieght: Number(curr.freight),
          depoExpense: Number(curr.depoExp),
          purchaseVoucherNo: Number(voucher),
          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
          approved: user.authorized === true ? true : false

        },
      ];
    }, []);

    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllSupplierSearch(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTankByCode = async () => {
    const data = await getTankById(state.code, access_token);
    if (data.success) {
      setState({
        ...state,
        tanks: data.data,
        tank: data.data[0].tankNumber,
        saleRate: data.data[0].item.saleRate,
        purchaseRate: data.data[0].item.purchaseRate,
      });
    }
  };

  useEffect(() => {
    // if (state.code) {
    //   getTankByCode();
    // }
    if (type === "SAVE") {
      if (state.code) {
        getTankByCode();
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.code]);

  const getTankEditByCode = async () => {
    const data = await getTankById(state.code, access_token);
    if (data.success) {
      setState({
        ...state,
        tanks: data.data,
      });
    }
  };

  useEffect(() => {
    // if (state.code) {
    //   getTankByCode();
    // }
    if (type === "EDIT") {
      if (state.code) {
        getTankEditByCode();
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.code]);

  const itemRateUpdate = async () => {
    let newRate = {
      itemCode: state.code,
      purchaseRate: state.purchaseRate,
    };
    await updateSingleItem(newRate, access_token);
  };

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    if (
      !state.code ||
      !state.partyId ||
      !state.glCode ||
      !state.quantity ||
      !(state.cashAmount || state.creditAmount)
    ) {
      return message.error(
        `Please type ${
          !state.code
            ? "item"
            : !state.glCode
            ? "GL code"
            : !state.partyId
            ? "Party Id"
            : !state.quantity
            ? "quantity"
            : !(state.cashAmount || state.creditAmount)
            ? "cash amount/credit amount"
            : ""
        }`
      );
    } else {
      setItemsQueue([...itemsQueue, state]);
      itemRateUpdate();

      clearState();
      const nextInput = inputRefs["itemCode"];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  console.log(itemsQueue, "items queue-=-=--=");
  // -------- EDIT ITEM

  const editItem = async () => {
    if (state.id) {
      await updateSingleApi();
    } else {
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // -------- EDIT ITEM

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);

    clearState();
  };

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            // refrenceNumber: curr.invoiceNo,
            code: curr.itemCode,
            glDescription: curr.chartOfAccount.description,
            name: curr.item.itemName,
            partyName: curr.party.partyName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            cashAmount: Number(curr.cashAmount),
            withHoldingTax: Number(curr.withHoldingTax),
            description: "",
            creditAmount: Number(curr.creditAmount),
            tank: curr.tankNumber,
            invoiceNo: curr.invoiceNumber,
            invoiceDate: curr.invoiceDate,
            glCode: curr.generalLedgerCode,
            saleRate: Number(curr.saleRate),
            salesTax: Number(curr.saleTax),
            rebate: Number(curr.gst),
            shortDip: Number(curr.shortDip),
            shortQty: Number(curr.shortQuantity),
            lorryNo: curr.lorryNumber,
            freight: Number(curr.frieght),
            depoExp: Number(curr.depoExpense),
            tanks: state.tanks,
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      id: state.id,
      partyId: Number(state.partyId),
      // refrenceNumber: state.invoiceNo,
      itemCode: state.code,
      quantity: Number(state.quantity),
      purchaseRate: Number(state.purchaseRate),
      cashAmount: Number(state.cashAmount),
      withHoldingTax: Number(state.withHoldingTax),
      description: "",
      creditAmount: Number(state.creditAmount),
      tankNumber: state.tank,
      invoiceNumber: state.invoiceNo,
      invoiceDate: state.invoiceDate,
      generalLedgerCode: state.glCode,
      saleRate: Number(state.saleRate),
      saleTax: Number(state.salesTax),
      gst: Number(state.rebate),
      shortDip: Number(state.shortDip),
      shortQuantity: Number(state.shortQty),
      lorryNumber: state.lorryNo,
      frieght: Number(state.freight),
      depoExpense: Number(state.depoExp),
    };

    const response = await updatePurchase(payload, access_token);
    if (response.success) {
      await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  // ---------------- DELETE PURCHASE

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (id) => {
    const results = await deleteSingleInvoivce(id, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this invoice?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(id),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteInvoivce(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };

  const descVoucher = async () => {
    const results = await descPurchase(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            // refrenceNumber: curr.invoiceNo,
            code: curr.itemCode,
            glDescription: curr.chartOfAccount.description,
            name: curr.item.itemName,
            partyName: curr.party.partyName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            cashAmount: Number(curr.cashAmount),
            withHoldingTax: Number(curr.withHoldingTax),
            description: "",
            creditAmount: Number(curr.creditAmount),
            tank: curr.tankNumber,
            invoiceNo: curr.invoiceNumber,
            invoiceDate: curr.invoiceDate,
            glCode: curr.generalLedgerCode,
            saleRate: Number(curr.saleRate),
            salesTax: Number(curr.saleTax),
            rebate: Number(curr.gst),
            shortDip: Number(curr.shortDip),
            shortQty: Number(curr.shortQuantity),
            lorryNo: curr.lorryNumber,
            freight: Number(curr.frieght),
            depoExp: Number(curr.depoExpense),
            tanks: state.tanks,
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].purchaseVoucherNo);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);
      console.log(itemsQueue, "dsiiiiii");

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const ascVoucher = async () => {
    const results = await ascPurchase(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            // refrenceNumber: curr.invoiceNo,
            code: curr.itemCode,
            glDescription: curr.chartOfAccount.description,
            name: curr.item.itemName,
            partyName: curr.party.partyName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            cashAmount: Number(curr.cashAmount),
            withHoldingTax: Number(curr.withHoldingTax),
            description: "",
            creditAmount: Number(curr.creditAmount),
            tank: curr.tankNumber,
            invoiceNo: curr.invoiceNumber,
            invoiceDate: curr.invoiceDate,
            glCode: curr.generalLedgerCode,
            saleRate: Number(curr.saleRate),
            salesTax: Number(curr.saleTax),
            rebate: Number(curr.gst),
            shortDip: Number(curr.shortDip),
            shortQty: Number(curr.shortQuantity),
            lorryNo: curr.lorryNumber,
            freight: Number(curr.frieght),
            depoExp: Number(curr.depoExpense),
            tanks: state.tanks,
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].purchaseVoucherNo);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);
      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const onePreVoucher = async () => {
    let data = {
      purchaseVoucherNo: voucher,
    };
    const results = await onePreData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            // refrenceNumber: curr.invoiceNo,
            code: curr.itemCode,
            glDescription: curr.chartOfAccount.description,
            name: curr.item.itemName,
            partyName: curr.party.partyName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            cashAmount: Number(curr.cashAmount),
            withHoldingTax: Number(curr.withHoldingTax),
            description: "",
            creditAmount: Number(curr.creditAmount),
            tank: curr.tankNumber,
            invoiceNo: curr.invoiceNumber,
            invoiceDate: curr.invoiceDate,
            glCode: curr.generalLedgerCode,
            saleRate: Number(curr.saleRate),
            salesTax: Number(curr.saleTax),
            rebate: Number(curr.gst),
            shortDip: Number(curr.shortDip),
            shortQty: Number(curr.shortQuantity),
            lorryNo: curr.lorryNumber,
            freight: Number(curr.frieght),
            depoExp: Number(curr.depoExpense),
            tanks: state.tanks,
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].purchaseVoucherNo);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const oneNextVoucher = async () => {
    let data = {
      purchaseVoucherNo: voucher,
    };
    const results = await oneNextData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            // refrenceNumber: curr.invoiceNo,
            code: curr.itemCode,
            glDescription: curr.chartOfAccount.description,
            name: curr.item.itemName,
            partyName: curr.party.partyName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            cashAmount: Number(curr.cashAmount),
            withHoldingTax: Number(curr.withHoldingTax),
            description: "",
            creditAmount: Number(curr.creditAmount),
            tank: curr.tankNumber,
            invoiceNo: curr.invoiceNumber,
            invoiceDate: curr.invoiceDate,
            glCode: curr.generalLedgerCode,
            saleRate: Number(curr.saleRate),
            salesTax: Number(curr.saleTax),
            rebate: Number(curr.gst),
            shortDip: Number(curr.shortDip),
            shortQty: Number(curr.shortQuantity),
            lorryNo: curr.lorryNumber,
            freight: Number(curr.frieght),
            depoExp: Number(curr.depoExpense),
            tanks: state.tanks,
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].purchaseVoucherNo);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const chkAlert = async () => {
    try {
      const getCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}/${month}/${day}`;
      };

      const getD = getCurrentDate();
      let data = {
        enteredOn: getD,
      };

      const results = await getAlert(data, access_token);

      if (Array.isArray(results.data)) {
        results.data.forEach((alert) => {
          const handleButtonClick = async () => {
            console.log(alert.id); // Replace with your desired action
            const results = await deleteSale(alert.id, access_token);
          };

          message.info({
            content: (
              <div>
                {` Amount Notification ${alert.description}, Amount: ${alert.amount}`}
                <Button
                  type="primary"
                  size="small"
                  onClick={handleButtonClick}
                  style={{ marginLeft: "10px" }}
                >
                  Delete
                </Button>
              </div>
            ),
            className: "custom-message",
          });
        });
      } else if (results.data) {
        const handleButtonClick = async () => {
          const results = await deleteSale(results.data.id, access_token);
        };

        message.info({
          content: (
            <div>
              {`${results.data.description}, ${results.data.amount}`}
              <Button
                type="primary"
                size="small"
                onClick={handleButtonClick}
                style={{ marginLeft: "10px" }}
              >
                Action
              </Button>
            </div>
          ),
          className: "custom-message",
        });
      }
    } catch (error) {
      console.error("Error fetching alert:", error);
    }
  };

  useEffect(() => {
    chkAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
            }}
          >
            Edit
          </button>
        </Menu.Item>
        <Menu.Item key="1">
          <button
            onClick={() => {
              itemsQueue[index].id
                ? confirmDelete(itemsQueue[index].id)
                : deleteItem(index);
            }}
          >
            {" "}
            Delete
          </button>
        </Menu.Item>
      </Menu>
    );
  };

  let totalSum = 0;
  itemsQueue.forEach((ele) => {
    totalSum += ele.creditAmount;
  });

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "tankNumber") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          "itemCode",
          "accountName",
          "quantity",
          "purchaseRate",
          "creditAmount",
          "invoiceNo",
          "invoiceDate",
          "lorryNo",
          "tankNumber",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black purchas-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  purchaseMain">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox pt-2 flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              STOCK ITEM PURCHASE
            </h3>
            <input
              readOnly
              placeholder="Voucher no#"
              value={voucher}
              className="inpTxtVoucher custom-select p-3  mr-10 mt-2 w-40"
            />
          </div>
          <div className="bg-blue-500 pb-3">
            <div
              className="flex content-center ml-10 "
              style={{
                display: "flow-root",
              }}
            >
              <input
                type="date"
                value={dateEntered}
                className="custom-select   mt-2 p-3"
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />
              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                className=" custom-select ml-3 mt-2 p-3"
                onChange={(e) => setShift(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              {fieldsShow && (
                <>
                  <Select
                    showSearch
                    disabled={Boolean(state.glCode)}
                    className="custom-select bg-white mt-2 ml-3 p-1 w-36"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.generalLedgerCode}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    disabled={Boolean(state.glCode)}
                    className="custom-select bg-white mt-2 ml-3 p-1 w-40"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description "}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.description}
                      </Option>
                    ))}
                  </Select>

                  <Select
                    showSearch
                    placeholder="A/C No."
                    className="custom-select bg-white ml-3 mt-2 mr-3 p-1 w-52"
                    optionFilterProp="children"
                    value={state.partyId || "A/C No."}
                    onChange={(e) => {
                      console.log("e", e);

                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: _party.PartyName,
                          glCode: _party.chartOfAccount.generalLedgerCode,
                          glDescription: _party.chartOfAccount.description,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: "",
                          glCode: "",
                          glDescription: "",
                        });
                      }
                    }}
                  >
                    <Option value={0}>None</Option>
                    {state.parties.map((el) => (
                      <Option value={el.partyId}>{el.partyId}</Option>
                    ))}
                  </Select>
                </>
              )}
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap ml-10">
                <Select
                  showSearch
                  placeholder="Select item"
                  name="itemCode"
                  className="bg-black text-white  mt-2 inpTxt  p-1 h-9  w-48"
                  optionFilterProp="children"
                  value={state.code || "Item"}
                  onChange={(e) => {
                    const { itemName: productName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({ ...state, code: e, name: productName });
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "itemCode")}
                  ref={(ref) => addInputFieldRef(ref, "itemCode")}
                >
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>
                      {el.itemCode} - {el.itemName}
                    </Option>
                  ))}
                </Select>
                {/* <Select
                  showSearch
                  placeholder="Select Product Name"
                  optionFilterProp="children"
                  className="bg-black text-white  inpTxt mt-2 p-1 h-9 ml-2 w-20"
                  value={state.name || "Prodct Name"}
                  onChange={(e) => {
                    const { itemName: productName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({ ...state, code: e, name: productName });
                  }}
                >
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>{el.itemName}</Option>
                  ))}
                </Select> */}

                <div className="">
                  <Select
                    showSearch
                    placeholder="Supplier Name"
                    name="accountName"
                    className=" bg-black text-white  inpTxt mt-2  p-1 h-9 ml-2 w-48"
                    optionFilterProp="children"
                    value={state.partyName || "Supplier Name"}
                    onChange={(e) => {
                      const { PartyName, chartOfAccount } = state.parties.find(
                        (el) => el.partyId === e
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: PartyName,
                        glCode: chartOfAccount.generalLedgerCode,
                        glDescription: chartOfAccount.description,
                      });
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "accountName")}
                    ref={(ref) => addInputFieldRef(ref, "accountName")}
                  >
                    {state.parties.map((el) => (
                      <Option
                        value={el.partyId}
                      >{`${el.partyId} - ${el.PartyName}`}</Option>
                    ))}
                  </Select>
                </div>
                <input
                  type="number"
                  name="quantity"
                  id=""
                  value={state.quantity}
                  // onChange={onChangeText}
                  onChange={(e) => {
                    if (state.purchaseRate) {
                      setState({
                        ...state,
                        creditAmount: e.target.value * state.purchaseRate,
                        quantity: e.target.value,
                      });
                    } else {
                      setState({ ...state, quantity: e.target.value });
                    }
                  }}
                  placeholder="Quantity"
                  className="bg-black text-slate-400 inpTxt p-2 mt-2 h-9 ml-2  w-20"
                  onKeyDown={(e) => handleEnterKey(e, "quantity")}
                  ref={(ref) => addInputFieldRef(ref, "quantity")}
                />
                <input
                  type="number"
                  name="purchaseRate"
                  id=""
                  value={state.purchaseRate}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        creditAmount: e.target.value * state.quantity,
                        purchaseRate: e.target.value,
                      });
                    } else {
                      setState({ ...state, purchaseRate: e.target.value });
                    }
                  }}
                  placeholder="P/Rate"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                  onKeyDown={(e) => handleEnterKey(e, "purchaseRate")}
                  ref={(ref) => addInputFieldRef(ref, "purchaseRate")}
                />
                <input
                  type="number"
                  name="saleRate"
                  hidden
                  id=""
                  value={state.saleRate}
                  onChange={onChangeText}
                  placeholder="Sale Rate"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                  onKeyDown={(e) => handleEnterKey(e, "saleRate")}
                  ref={(ref) => addInputFieldRef(ref, "saleRate")}
                />
                <input
                  type="number"
                  name="creditAmount"
                  id=""
                  disabled={Boolean(state.cashAmount)}
                  value={state.creditAmount}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        purchaseRate: e.target.value / state.quantity,
                        creditAmount: e.target.value,
                      });
                    } else {
                      setState({ ...state, creditAmount: e.target.value });
                    }
                  }}
                  placeholder="Credit Amount"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-28"
                  onKeyDown={(e) => handleEnterKey(e, "creditAmount")}
                  ref={(ref) => addInputFieldRef(ref, "creditAmount")}
                />
                <input
                  type="text"
                  id=""
                  placeholder="Rebate"
                  name="rebate"
                  value={state.rebate}
                  onChange={onChangeText}
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                />
                <input
                  type="number"
                  id=""
                  name="withHoldingTax"
                  value={state.withHoldingTax}
                  onChange={onChangeText}
                  placeholder="W/H Tax"
                  className="bg-black text-slate-400 mt-2 inpTxt p-2 h-9 ml-2  w-16"
                />
                <input
                  type="number"
                  name="salesTax"
                  value={state.salesTax}
                  onChange={onChangeText}
                  id=""
                  placeholder="Salex Tax"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                />
                <input
                  type="number"
                  name="freight"
                  value={state.freight}
                  onChange={onChangeText}
                  placeholder="Frieght/L"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                />
                <input
                  type="number"
                  name="lorryTip"
                  value={state.lorryTip}
                  onChange={onChangeText}
                  placeholder="Lorry Tip"
                  className=" bg-black text-white inpTxt mt-2 p-1 h-9  w-28"
                />
                <input
                  type="number"
                  name="depoExp"
                  value={state.depoExp}
                  onChange={onChangeText}
                  placeholder="Depo Exp."
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-20"
                />
                <input
                  type="text"
                  name="cmpRate"
                  value={state.cmpRate}
                  onChange={onChangeText}
                  placeholder="CMP Rate"
                  className=" bg-black text-white inpTxt mt-2 p-1 h-9 ml-2 w-20"
                />
                <input
                  type="text"
                  name="invoiceNo"
                  value={state.invoiceNo}
                  onChange={onChangeText}
                  placeholder="Invoice No"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-20"
                  onKeyDown={(e) => handleEnterKey(e, "invoiceNo")}
                  ref={(ref) => addInputFieldRef(ref, "invoiceNo")}
                />
                <input
                  type="date"
                  name="invoiceDate"
                  value={state.invoiceDate}
                  onChange={onChangeText}
                  className="inpTxt mt-2 dateInp bg-black text-slate-400  p-2 h-9 ml-2 w-28"
                  onKeyDown={(e) => handleEnterKey(e, "invoiceDate")}
                  ref={(ref) => addInputFieldRef(ref, "invoiceDate")}
                />
                <input
                  type="text"
                  name="lorryNo"
                  value={state.lorryNo}
                  onChange={onChangeText}
                  placeholder="Lorry No"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                  onKeyDown={(e) => handleEnterKey(e, "lorryNo")}
                  ref={(ref) => addInputFieldRef(ref, "lorryNo")}
                />
                <input
                  type="number"
                  name="shortDip"
                  value={state.shortDip}
                  onChange={onChangeText}
                  placeholder="Short Dip"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                />
                <input
                  type="number"
                  name="shortQty"
                  value={state.shortQty}
                  onChange={onChangeText}
                  placeholder="Short Qty"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-16"
                />
                <input
                  type="text"
                  name="cheque"
                  value={state.cheque}
                  onChange={onChangeText}
                  placeholder="Chq/DD"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-2  w-20"
                />
                <Select
                  showSearch
                  placeholder="Tank"
                  name="tankNumber"
                  optionFilterProp="children"
                  className="bg-black text-white  inpTxt  mt-2 p-1 h-9 ml-2 w-20"
                  value={state.tank || "Tank"}
                  onChange={(e) => {
                    setState({ ...state, tank: e });
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "tankNumber")}
                  ref={(ref) => addInputFieldRef(ref, "tankNumber")}
                >
                  {state.tanks.map((el) => (
                    <Option value={el.tankNumber}>{el.tankNumber}</Option>
                  ))}
                </Select>
                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-2  w-16 text-sm  rounded"
                  >
                    EDIT
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white text-sm mt-2 ml-2  w-16 rounded"
                  >
                    ADD +
                  </button>
                )}
              </div>
            </div>
          )}
          <div
            class="overflow-x-auto m-10 mr-10 mt-4 tableDiv"
            style={{ maxHeight: "400px" }}
          >
            <table class="min-w-full  divide-y divide-gray-200">
              <thead>
                <tr>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    SNo.
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    ITEM ID
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    ITEM
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Party
                  </th>
                  <th
                    className=" px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Party Name
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    QTY
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    P/Rate
                  </th>
                  {/* <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Cash
                  </th> */}
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Credit
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Rebate
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    W/H
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Sales Tax
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    GL
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    GL Desc.
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Freight
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Lorry Tip
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Depo Exp.
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    CMP
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Invoice
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Invoice Date
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Lorry No.
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Short Dip
                  </th>{" "}
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Short Qty
                  </th>{" "}
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Cheque/DD
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    Tank
                  </th>
                  <th
                    className="px-6 fs-15 py-3 table-cell  bg-blue-500  text-left text-xs font-medium  uppercase tracking-wider"
                    scope="col"
                  >
                    ACTION
                  </th>
                </tr>
              </thead>

              <tbody className="tableBody bg-white divide-y divide-gray-200">
                {itemsQueue.map((ele, i) => {
                  return (
                    <tr key={i} className="tbodyData">
                      <td className="px-6 fs-15 py-3 table-cell   text-left text-xs  ">
                        {i + 1}
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.code}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.name}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.partyId}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="widthInc font-medium">{ele.partyName}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.quantity}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.purchaseRate}</p>
                      </td>
                      {/* <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.cashAmount}</p>
                      </td> */}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">
                          {ele.creditAmount}
                          {/* {parseFloat(ele.creditAmount.toFixed(2))} */}
                        </p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.rebate}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.withHoldingTax}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.salesTax}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.glCode}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="widthInc font-medium">
                          {ele.glDescription}
                        </p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.freight}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.lorryTip}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.depoExp}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.cmpRate}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.invoiceNo}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.invoiceDate}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.lorryNo}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.shortDip}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.shortQty}</p>
                      </td>{" "}
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.cheque}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <p className="font-medium">{ele.tank}</p>
                      </td>
                      <td className="px-6 fs-15 py-3  ">
                        <Dropdown overlay={menu(i)} placement="bottomLeft">
                          <Button>Action</Button>
                        </Dropdown>
                        {/* <button style={{
                                border: "1px solid",
                                padding: '5pxs'
                              }} onClick={() => null}>Edit</button>
                              <button style={{
                                border: "1px solid",
                                padding: '5pxs'
                              }} onClick={() => null}>Delete</button> */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="div">
            <div className="flex">
              <div className="overflow-x-auto   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full">
                {/* <input
                  type="text"
                  readOnly
                  placeholder=""
                  name=""
                  id=""
                  className="mt-2 p-1 w-full bg-black text-slate-400 outline-none"
                /> */}
                <div className="flex justify-between">
                  <div className="flex">
                    {type === "ADD" && (
                      <button
                        onClick={addVoucher}
                        className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={save}
                        className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                          isButtonDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={isButtonDisabled}
                      >
                        <AiFillSave className="mr-2 mt-1" />
                        <span>Save</span>
                      </button>
                    )}

                    {isVisible && type === "ADD" && (
                      <button
                        onClick={edit}
                        className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-6 fs-15 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}
                    {isVisible && type === "ADD" && (
                      <button
                        onClick={() => deletePurchase()}
                        className="bg-blue-500 hover:bg-blue-700 h-9  flex text-white mt-3 ml-3 py-1 px-6 fs-15 rounded"
                        disabled={type !== "ADD"}
                      >
                        <AiFillDelete className="mr-2 mt-1" />

                        <span>Delete</span>
                      </button>
                    )}
                    <button
                      onClick={() => {
                        clearStates();
                      }}
                      className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-6 fs-15 rounded"
                    >
                      {" "}
                      <BiExit className="mr-2 mt-1" />
                      {type === "EDIT" ? "Done" : "Exit"}
                    </button>
                  </div>

                  {isVisible && (
                    <div className="flex content-end justify-end">
                      {type === "ADD" && (
                        <button
                          onClick={ascVoucher}
                          className="bg-black hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/first.png`} alt="" />
                        </button>
                      )}
                      {typeLast === "LAST" && (
                        <button
                          onClick={onePreVoucher}
                          className="bg-black hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/previous.png`} alt="" />
                        </button>
                      )}
                      {typeLast === "LAST" && (
                        <button
                          onClick={oneNextVoucher}
                          className="bg-black hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/next.png`} alt="" />
                        </button>
                      )}
                      {type === "ADD" && (
                        <button
                          onClick={descVoucher}
                          className="bg-black hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/latest.png`} alt="" />
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex justify-between pt-5 pb-5">
                  <div>
                    <div class="flex items-center">
                      <span class="mr-2 text-xs font-medium text-white">
                        Total Amount
                      </span>
                      <input
                        readOnly
                        type="text"
                        value={totalSum}
                        class="bg-black text-slate-400 inpTxt p-2 h-9 ml-1  w-48"
                      />
                    </div>
                  </div>
                  <div className=" ml-3">
                    <div class="flex items-center">
                      <span class="mr-2 text-xs font-medium text-white">
                        Total W/O Taxes
                      </span>
                      <input
                        type="text"
                        class="bg-black text-slate-400 inpTxt p-2 h-9 ml-1  w-20"
                      />
                    </div>
                  </div>

                  <div className="ml-3">
                    <div class="flex items-center">
                      <span class="mr-2 text-xs font-medium text-white">
                        Total Incl Taxes
                      </span>
                      <input
                        type="text"
                        class="bg-black text-slate-400 inpTxt p-2 h-9 ml-1  w-20"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={deletePurchaseHandler}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default Purchase;
